import ProductPage from './ProductPage'

export { ProductPage }
